module.exports = __webpack_public_path__ + "static/media/wordmark_white.0472abb0.svg";